import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  logout_user_action,
  user_meta_data_action,
  get_mentor_dashboard_data_action,
} from "../../../redux/_actions";
import { useNavigate } from "react-router-dom";
function useHiringPipeline(props) {
  const userInLocalStorage = JSON.parse(localStorage.getItem("jigsawUser"));
  const [allAssignedJobs, setAllAssignedJobs] = useState({});
  const [assignedJobsLoading, setAssignedJobsLoading] = useState(false);
  const [userRole, setUserRole] = useState(null);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { userMetaData } = useSelector((state) => state.user_meta_data_reducer);
  const { mentorDashboardData } = useSelector(
    (state) => state.get_mentor_dashboard_data_reducer
  );

  useEffect(() => {
    getUserMetaData();
    getAssignedJobs();
  }, []);


  useEffect(() => {
    if (mentorDashboardData?.data) {
      setAllAssignedJobs(mentorDashboardData?.data);
    }
  }, [mentorDashboardData]);

  const getAssignedJobs = async () => {
    setAssignedJobsLoading(true);
    await dispatch(get_mentor_dashboard_data_action());

    setAssignedJobsLoading(false);
  };

  useEffect(() => {
    if (userMetaData) {
      if (userMetaData?.role) setUserRole(userMetaData?.role);
    }
  }, [userMetaData]);

  // calendarAvailabilityListsData
  const getUserMetaData = async () => {
    await dispatch(user_meta_data_action());
  };
  const kanbanBoardHandler = (id) => {
    if(userRole === "mentor")
    navigate(`/mentor-kanboard/${id}`, {
      state: { id: id },
    });
  };
  return {
    allAssignedJobs,
    assignedJobsLoading,kanbanBoardHandler
  };
}
export default useHiringPipeline;
